import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo, Navigation } from '../../components';
import './Header.scss';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    document.body.classList.toggle('no-scroll', menuOpen);
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [menuOpen]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 769px)');
    const handleResize = () => {
      if (mediaQuery.matches) {
        setMenuOpen(false);
        document.body.classList.remove('no-scroll');
      }
    };
    handleResize();
    mediaQuery.addEventListener('change', handleResize);
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  return (
    <header className="header">
      <Logo onClick={closeMenu} />
      <nav className="desktop-nav">
        <Navigation />
      </nav>
      <button className="menu-toggle" onClick={toggleMenu}>
        {menuOpen ? <X size={32} /> : <Menu size={32} />}
      </button>
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          <Navigation onClick={closeMenu} />
        </nav>
      </div>
    </header>
  );
};

export default Header;
